import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=a227e46a&"
import script from "./TheLayout.vue?vue&type=script&lang=js&"
export * from "./TheLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheLayout.vue?vue&type=style&index=0&id=a227e46a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports